module.exports = __webpack_public_path__ + "img/Quantum words TP.1d9f1666.png";